import Vue from 'vue'
import Router from 'vue-router'
import Signup from '@/components/auth/Signup'
import Login from '@/components/auth/Login'
import ViewProfile from '@/components/profile/ViewProfile'
import ViewListing from '@/components/listing/ViewListing'
import Home from '@/components/home/Home'
import UserHome from '@/components/user/UserHome'
import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        //default route
        {
            path: '*',
            component: Home
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup
        }, {
            path: '/login',
            name: 'Login',
            component: Login
        }, {
            path: '/profile/:id',
            name: 'ViewProfile',
            component: ViewProfile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/listing/:id',
            name: 'ViewListing',
            component: ViewListing,
            meta: {
                requiresAuth: true
            }
        }, {
            path: '/userHome/:email',
            name: 'UserHome',
            component: UserHome,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
        let user = firebase.auth().currentUser

        //check to see if route requires auth
        if (to.matched.some(rec => rec.meta.requiresAuth)) {
            //check auth state of user

            if (user) {
                next()
            } else {
                next({name: 'Login'})
            }
        } else {
            if (user && to.fullPath === '/') {
                next({name: 'UserHome', params:{email: user.email}})
            }
            else {
                next()
            }
        }
    }
)

export default router


// WEBPACK FOOTER //
// ./src/router/index.js